export const MESSAGES = {
    required: 'Required',
    invalidEmail: 'Invalid email',
    invalidMobileNumber: 'Invalid mobile number',
    createUserFailed: 'Error while creating user',
    createUserSuccess: 'User created successfully',
    updateUserFailed: 'Error while updating user',
    updateUserSuccess: 'User updated successfully',
}